/**
 * Quick-test sensitivity helpers — apply vs baseline (not compounded).
 */

export function applySensitivityFromBaseline(baseline, field, factor) {
  return Math.round(baseline[field] * factor);
}

export function oppositeTestsDoNotCompound(baselinePrice) {
  const up = applySensitivityFromBaseline({ pricePerSqm: baselinePrice }, 'pricePerSqm', 1.1);
  const down = applySensitivityFromBaseline({ pricePerSqm: baselinePrice }, 'pricePerSqm', 0.9);
  return { up, down, restoredWouldBe: baselinePrice };
}

/** True when current value no longer matches the active sensitivity projection. */
export function shouldInvalidateBaselineField(baseline, field, factor, currentValue) {
  if (!baseline || factor == null) {
    return baseline != null && currentValue !== baseline[field];
  }
  return currentValue !== applySensitivityFromBaseline(baseline, field, factor);
}
